
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/site/docs",
      function () {
        return require("private-next-pages/site/docs.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/site/docs"])
      });
    }
  